import { FC } from "react";
import { Column, Row } from "../../../../containers";
import { AlignItems, JustifyContent } from "../../../../containers/types";
import { styles } from "../styles";
import StatusPicture from "../../../../status-picture";
import { Text } from "../../../../typography";
import {
  usePopupStore,
  useThemeStore,
  useUserStore,
} from "../../../../../stores";
import { BellIcon, ChatIcon, NotifIcon } from "../../../../../assets/icons";
import {
  UserProps,
  UserStatus,
} from "../../../../../pages/admin-panel/users/types";
import { UserProfilePopup } from "../../../../../pages/admin-panel/users/user";

const NavHeader: FC = () => {
  const theme = useThemeStore((state) => state.theme);
  const user = useUserStore((s) => s.user);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);

  const onProfileClick = (): void => {
    setPopupBody(
      <UserProfilePopup {...(user as UserProps)} status={UserStatus.Online} />
    );
  };

  return (
    <Row justifyContent={JustifyContent.Start} gap={40} style={styles.header}>
      <StatusPicture
        src={user?.pic ?? require("../../../../../assets/images/profile.jpg")}
        type={"big"}
        status={UserStatus.Online}
        style={{ marginTop: 10 }}
        onClick={onProfileClick}
      />
      <Column
        alignItems={AlignItems.Start}
        justifyContent={JustifyContent.Between}
        style={{ height: "100%" }}
      >
        <Text size={14} color={theme.textOnOverlay}>
          {user?.fullname || "<username>"}
        </Text>
        <Row
          style={{ width: "100%" }}
          justifyContent={JustifyContent.Start}
          gap={15}
        >
          <NotifIcon
            Icon={BellIcon}
            hasNotif
            width={20}
            height={20}
            style={{ cursor: "pointer" }}
          />
          <NotifIcon
            Icon={ChatIcon}
            hasNotif
            width={20}
            height={20}
            style={{ cursor: "pointer" }}
          />
        </Row>
      </Column>
    </Row>
  );
};

export default NavHeader;
